<div class="notification-bell-container" ngbDropdown placement="bottom-right" (openChange)="onDropdownOpenChange($event)">
  <button type="button"
    class="hc-topbar__link-btn"
    ngbDropdownToggle
    [attr.aria-label]="'HEADER.NOTIFICATIONS.TITLE' | translate">
    <span class="bell-icon-wrapper">
      <lucide-icon name="bell" [size]="24" aria-hidden="true"></lucide-icon>
      @if ((unreadCount$ | async); as count) {
        @if (count > 0) {
          <span class="notification-badge">{{ count > 99 ? '99+' : count }}</span>
        }
      }
    </span>
    <span class="hc-topbar__link-label d-none d-lg-inline">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate }}</span>
  </button>

  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end notification-dropdown"
    ngbDropdownMenu
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="dropdown-header d-flex justify-content-between align-items-center">
      <h6 class="mb-0">
        {{ 'HEADER.NOTIFICATIONS.TITLE' | translate }}
        @if ((unreadCount$ | async); as count) {
          <hc-badge
            color="secondary" variant="heavy" size="small"
            class="ms-2"
            [class.d-none]="count === 0">
            {{ count }}
          </hc-badge>
        }
      </h6>
      <button class="btn btn-link btn-sm text-decoration-none p-0"
        (click)="markAllAsRead()"
        [title]="'HEADER.NOTIFICATIONS.VIEW_ALL' | translate">
        <lucide-icon name="check-check"></lucide-icon>
      </button>
    </div>

    <div class="dropdown-divider"></div>

    <!-- Loading State -->
    @if (loading$ | async) {
      <div class="text-center p-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
        </div>
      </div>
    }

    <!-- Notifications List -->
    @if (notifications$ | async; as notifications) {
      <div class="notification-list">
        @if (getPreviewNotifications(notifications); as previewNotifications) {
          <!-- Empty State -->
          @if (previewNotifications.length === 0) {
            <div class="text-center p-3 text-muted">
              <lucide-icon name="bell-off" class="display-6"></lucide-icon>
              <p class="mb-0 mt-2">{{ 'HEADER.NOTIFICATIONS.NO_NEW_NOTIFICATIONS' | translate }}</p>
            </div>
          }
          <!-- Notification Items -->
          @for (notification of previewNotifications; track trackByNotificationId($index, notification)) {
            <a
              class="dropdown-item notification-item"
              [class.unread]="!notification.isRead"
              (click)="handleNotificationClick(notification)"
              (keydown.enter)="handleNotificationClick(notification)"
              tabindex="0"
              role="button">
              <div class="d-flex p-0">
                <div class="notification-icon me-3">
                  <lucide-icon [name]="getNotificationIcon(notification)" [class]="getNotificationColor(notification)"></lucide-icon>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start p-0">
                    <h6 class="mb-1 notification-title">{{ notification.titleKey ? (notification.titleKey | translate) : notification.title }}</h6>
                    <small class="text-muted notification-time text-nowrap">{{ notification.timeAgo }}</small>
                  </div>
                  <p class="mb-1 notification-message">{{ truncateMessage(notification.body) }}</p>
                  <div class="d-flex justify-content-between align-items-center p-0">
                    <small class="text-muted">{{ notification.hotel?.name }}</small>
                    <div class="notification-actions">
                      @if (!notification.isRead) {
                        <button
                          class="btn btn-link btn-sm text-decoration-none p-0 me-2"
                          (click)="markAsRead(notification, $event)"
                          [title]="'HEADER.NOTIFICATIONS.MARK_AS_READ' | translate">
                          <lucide-icon name="check" class="text-success"></lucide-icon>
                        </button>
                      }
                      @if (notification.priority === 'urgent') {
                        <hc-badge
                          color="primary" variant="heavy" size="small">
                          {{ 'HEADER.NOTIFICATIONS.URGENT' | translate }}
                        </hc-badge>
                      }
                      @if (!notification.isRead) {
                        <span
                        class="notification-unread-dot"></span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </a>
          }
        }
      </div>
    }

    <!-- Footer -->
    @if ((notifications$ | async)?.length) {
      <div class="dropdown-divider"></div>
    }
    <div class="dropdown-footer">
      <button class="btn btn-link btn-sm w-full text-decoration-none"
        (click)="viewAllNotifications()">
        <lucide-icon name="arrow-right" class="me-1"></lucide-icon>
        {{ 'HEADER.NOTIFICATIONS.VIEW_ALL_NOTIFICATIONS' | translate }}
      </button>
    </div>

  </div>
</div>
